import React, {useEffect, useState} from "react";
import axios from "axios";
import {useLocation} from "react-router-dom";
import {baseUrl} from "../Univ.js";
function useQuery() {
    return new URLSearchParams(useLocation().search);
}
function PharmQuotationCompare() {
    const query = useQuery();
    const ids = query.get("ids")?.split(",") || [];
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [quotations, setQuotations] = useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        try {
            const qRes = await axios.get(`${baseUrl}pharm-vendor-quotation/`);
            const iRes = await axios.get(`${baseUrl}pharm-vendor-quotation-item/`);
            const selected = qRes.data.filter(q =>
                ids.includes(String(q.id))
            );
            setQuotations(selected);
            let map = {};
            selected.forEach(q => {
                const items = iRes.data.filter(
                    i => i.quotation?.id === q.id
                );
                items.forEach(item => {
                    if (!map[item.product]) {
                        map[item.product] = [];
                    }
                    map[item.product].push({
                        vendor: q.vendor?.name,
                        quotation_no: q.quotation_no,
                        total: parseFloat(q.total_amount),
                        rate: parseFloat(item.rate),
                        qty: item.qty
                    });
                });
            });
            // find best price (lowest rate)
            Object.keys(map).forEach(p => {
                const min = Math.min(...map[p].map(x => x.rate));
                map[p] = map[p].map(x => ({
                    ...x,
                    is_lowest: x.rate === min
                }));
            });
            setData(map);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="container-fluid mt-3">

            <h3 className="text-center mb-3">
                Quotation Comparison
            </h3>

            {/* HEADER: selected quotations */}
            <div className="mb-3">
                <h5>Selected Quotations</h5>
                <ul>
                    {quotations.map(q => (
                        <li key={q.id}>
                            {q.quotation_no} - {q.vendor?.name} - ₹{q.total_amount}
                        </li>
                    ))}
                </ul>
            </div>

            <div className="table-responsive">

                <table className="erp-table-modern">

                    <thead style={{background: "#1bc5ce", color: "white"}}>
                    <tr>
                        <th>Product</th>
                        <th>Vendor</th>
                        <th>Quotation No</th>
                        <th>Qty</th>
                        <th>Rate</th>
                        <th>Status</th>
                    </tr>
                    </thead>

                    <tbody>

                    {
                        loading ? (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    Loading...
                                </td>
                            </tr>
                        ) : Object.keys(data).length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center text-danger">
                                    No Comparison Data Found
                                </td>
                            </tr>
                        ) : (
                            Object.keys(data).map((product, i) =>
                                data[product].map((row, j) => (
                                    <tr key={`${i}-${j}`}>
                                        <td>{product}</td>
                                        <td>{row.vendor}</td>
                                        <td>{row.quotation_no}</td>
                                        <td>{row.qty}</td>
                                        <td>₹{row.rate}</td>
                                        <td>
                                            {row.is_lowest ? (
                                                <span className="badge bg-success">Lowest</span>
                                            ) : (
                                                <span className="badge bg-danger">Higher</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )
                        )
                    }

                    </tbody>

                </table>

            </div>

        </div>
    );
}
export default PharmQuotationCompare;